var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"client-emails"},[_c('ClientEmailsTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }